<template>
  <div class="main">
    <form @submit.prevent="submit()" class="profile" v-if="!changePassword">
      <div class="success" v-if="success">
        <i class="fas fa-check"></i>
        <h2>{{ $t("admin.changed_profile") }}</h2>
      </div>
      <div class="title">
        <div class="title-content">
          <h1>{{ $t("admin.profile") }}</h1>
          <div class="border"></div>
        </div>
        <button class="change" @click="changePassword = true">
          {{ $t("admin.changepassword") }}
        </button>
      </div>

      <div class="settings-input">
        <div class="name">
          <h3>{{ $t("admin.username") }}</h3>
          <input
            class="input"
            type="text"
            :placeholder="user.first_name"
            v-model="initialUser.first_name"
          />
        </div>
        <div class="surname">
          <h3>{{ $t("admin.surname") }}</h3>
          <input
            class="input"
            type="text"
            :placeholder="user.last_name"
            v-model="initialUser.last_name"
          />
        </div>
        <div class="login">
          <h3>{{ $t("admin.userlogin") }}</h3>
          <div class="login-message">
            <input
              class="input"
              type="text"
              v-model="initialUser.username"
              :placeholder="user.username"
            />
            <p v-for="(item, index) in errormessage.username" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
        <div class="email">
          <h3>{{ $t("admin.usermail") }}</h3>
          <div class="email-column">
            <input
              class="input"
              name="email"
              type="text"
              v-model="initialUser.email"
              :placeholder="user.email"
            />
            <label
              for="email"
              v-for="(item, index) in errormessage.email"
              :key="index"
            >
              {{ item }}
            </label>
          </div>
        </div>
        <div class="about">
          <h3>{{ $t("admin.userbio") }}</h3>
          <div class="text">
            <textarea
              class="textarea"
              maxlength="150"
              :placeholder="$t('admin.infbio')"
              v-model="initialUser.bio"
            ></textarea>
            <p>{{ $t("admin.maxwords") }}</p>
          </div>
        </div>
      </div>
      <div class="apply-mb">
        <button
          :disabled="
            !initialUser.first_name &&
            !initialUser.last_name &&
            !initialUser.username &&
            !initialUser.email &&
            !initialUser.bio
          "
          type="submit"
          class="apply"
        >
          {{ $t("admin.apply") }}
        </button>
      </div>
    </form>
    <div class="change-section" v-else>
      <div class="success" v-if="success">
        <i class="fas fa-check"></i>
        <h2>{{ $t("admin.changed_profile") }}</h2>
      </div>
      <div class="change-password-title">
        <div class="title-column">
          <h1>{{ $t("admin.changepassword") }}</h1>
          <div class="change-border"></div>
        </div>
        <button class="back" @click="changePassword = false">
          {{ $t("admin.return") }}
        </button>
      </div>
      <div class="check">
        <form @submit.prevent="setPassword()">
          <div class="input-fields">
            <input
              name="password"
              :type="show.password ? 'text' : 'password'"
              class="change-passsword"
              :placeholder="$t('admin.currentpassword')"
              v-model="passwords.password"
            />
            <label
              for="password"
              v-for="(item, index) in errormessage.current_password"
              :key="index"
            >
              {{ item }}
            </label>
            <div
              class="show-password"
              @click.prevent="show.password = !show.password"
            >
              <i class="fas fa-eye" v-if="show.password"></i>
              <i class="fas fa-eye-slash" v-if="!show.password"></i>
            </div>
          </div>
          <div class="input-fields">
            <input
              id="newpassword"
              :type="show.newPassword ? 'text' : 'password'"
              class="change-passsword"
              :placeholder="$t('admin.userpassword')"
              v-model="passwords.newPassword"
            />
            <small v-if="show.newPasswordLog"> {{ $t("admin.length") }} </small>
            <div
              class="show-password"
              @click.prevent="show.newPassword = !show.newPassword"
            >
              <i class="fas fa-eye" v-if="show.newPassword"></i>
              <i class="fas fa-eye-slash" v-if="!show.newPassword"></i>
            </div>
          </div>
          <div class="input-fields">
            <input
              id="confirmpassword"
              :type="show.confirmPassword ? 'text' : 'password'"
              class="change-passsword"
              :placeholder="$t('admin.replypassword')"
              v-model="passwords.replyPassword"
            />
            <label for="" v-if="errpassword">
              {{ $t("authorization.passwordMismatch") }}
            </label>
            <div
              class="show-password"
              @click.prevent="show.confirmPassword = !show.confirmPassword"
            >
              <i class="fas fa-eye" v-if="show.confirmPassword"></i>
              <i class="fas fa-eye-slash" v-if="!show.confirmPassword"></i>
            </div>
          </div>
          <div class="to-apply-mb">
            <button type="submit" class="to-apply">
              {{ $t("admin.apply") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { updateUser, userPassword } from "@/network/v1";

export default {
  setup() {
    const store = useStore();
    const initialUser = reactive({});
    const errormessage = reactive({});
    let isDisable = false;

    const success = ref(false);

    const passwords = reactive({
      password: "",
      newPassword: "",
      replyPassword: "",
    });

    const show = reactive({
      password: false,
      newPassword: false,
      newPasswordLog: false,
      confirmPassword: false,
    });

    const errpassword = ref(false);

    const changePassword = ref();

    const submit = () => {
      Object.keys(errormessage).forEach((key) => {
        delete errormessage[key];
      });
      const formData = new FormData();
      for (const name in initialUser) {
        formData.append(name, initialUser[name]);
        if (!initialUser) {
          return (isDisable = true);
        }
      }
      success.value = false;
      updateUser(
        () => {
          store.dispatch("getMe", {});
          success.value = true;
        },
        store.getters.access,
        formData,
        (body) => {
          console.log("err");
          for (const name in body) {
            errormessage[name] = body[name];
          }
          success.value = false;
        }
      );
    };

    const setPassword = () => {
      Object.keys(errormessage).forEach((key) => {
        delete errormessage[key];
      });

      const formData = new FormData();

      formData.append("new_password", passwords.newPassword);
      formData.append("current_password", passwords.password);

      success.value = false;

      userPassword(
        () => {
          console.log("cb");
          success.value = true;
          show.newPasswordLog = false;
        },
        store.getters.access,
        formData,
        (passwordmessage) => {
          for (const name in passwordmessage) {
            errormessage[name] = passwordmessage[name];
            console.log("err");
          }
          success.value = false;
        }
      );

      checkFields();
      // console.log(errormessage[message]);
      passworLength();
    };

    const checkFields = () => {
      if (passwords.newPassword != passwords.replyPassword) {
        return (errpassword.value = true);
      } else {
        errpassword.value = false;
      }
    };

    const passworLength = () => {
      if (passwords.newPassword.length < 8) {
        return (show.newPasswordLog = true);
      }
    };

    store.dispatch("getMe", {});

    return {
      user: computed(() => store.getters.user),
      passwords,
      show,
      changePassword,
      submit,
      initialUser,
      errormessage,
      setPassword,
      errpassword,
      checkFields,
      isDisable,
      passworLength,
      success,
    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: rgba(248, 248, 248, 1);
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2.5vw;
  .profile {
    display: flex;
    flex-direction: column;
    width: 33.906vw;
    background-color: rgba(0, 0, 0, 0.02);
    .success {
      display: flex;
      align-items: center;
      background: #f3ffe4;
      width: 90%;
      margin-left: 2vw;
      margin-top: 1.823vw;
      padding: 0.521vw 0;
      h2 {
        font-size: 1.042vw;
        line-height: 1.25vw;
        font-weight: 400;
        color: rgba(4, 167, 1, 1);
        margin-left: 0.781vw;
      }
      i {
        color: #04a701;
        font-size: 1.771vw;
        font-weight: 900;
        padding-left: 0.781vw;
      }
    }

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 1.042vw;
      h1 {
        font-size: 1.258vw;
        line-height: 1.719vw;
        font-weight: 400;
        font-style: normal;
        color: rgba(78, 101, 134, 1);
        padding-left: 2.083vw;
      }
      .border {
        width: 16.563vw;
        height: 2px;
        background-color: #4e6586;
        opacity: 0.2;
        margin-bottom: 2.344vw;
      }
      .change {
        background-color: transparent;
        border: transparent;
        color: rgba(92, 137, 201, 0.7);
        cursor: pointer;
        margin-bottom: 1.042vw;
        padding-top: 4.115vw;
        margin-left: 7.5vw;
        font-size: 0.838vw;
        line-height: 1.146vw;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.104vw;
          background: rgba(92, 137, 201, 0.7);
          opacity: 0;
          transform: scale(0);
        }

        &:hover::before {
          transform: scale(1);
          transition: all 0.4s ease;
          opacity: 1;
        }
      }
    }
    .settings-input {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .name,
      .login,
      .email,
      .surname,
      .about {
        display: grid;
        grid-template-areas: "title input";
        grid-template-columns: 5.833vw 16.667vw;
        gap: 2.5vw;
        margin-bottom: 1.875vw;
        font-size: 0.833vw;
        line-height: 1.042vw;
        font-weight: 300;
        color: #fff;
        .email-column {
          display: flex;
          flex-direction: column;
          label {
            color: rgba(211, 77, 77, 1);
            font-size: 0.729vw;
            line-height: 0.885vw;
            font-weight: 400;
            margin: 2px;
          }
        }
        h3 {
          color: rgba(123, 123, 123, 1);
          font-size: 1.042vw;
          line-height: 1.25vw;
          font-weight: 400;
          margin-top: 0.521vw;
          padding-right: 2.604vw;
          grid-area: title;
          width: max-content;
        }
        .login-message {
          display: flex;
          flex-direction: column;
          p {
            font-size: 0.833vw;
            line-height: 0.99vw;
            font-weight: 400;
            color: var(--error-message);
            margin-top: 0.521vw;
          }
        }
        .input {
          width: 17.708vw;
          height: 1.927vw;
          border: 1.5px solid rgba(92, 137, 201, 0.5);
          padding: 0.521vw;
          outline: none;
          grid-area: input;
          font-size: 0.833vw;
          line-height: 1.042vw;
          font-weight: 300;
        }
        .text {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          P {
            font-size: 0.875em;
            line-height: 1.026em;
            font-weight: 400;
            color: rgba(180, 187, 195, 1);
            margin-top: 0.188rem;
          }
          .textarea {
            width: 21.25em;
            height: 9.375em;
            padding: 0.625rem;
            outline: none;
          }
        }
      }
    }

    .apply-mb {
      margin-bottom: 1.875rem;
      margin-left: auto;
      margin-right: auto;
      .apply {
        background-color: transparent;
        outline: none;
        border: none;
        font-size: 1.458vw;
        line-height: 1.719vw;
        font-weight: 500;
        cursor: pointer;
        color: rgba(77, 114, 166, 1);
        transition: 0.4s ease;
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
  .change-section {
    display: flex;
    flex-direction: column;
    width: 33.906vw;
    background-color: rgba(0, 0, 0, 0.02);
    .success {
      display: flex;
      align-items: center;
      background: #f3ffe4;
      width: 90%;
      margin-left: 2vw;
      margin-top: 1.823vw;
      padding: 0.521vw 0;
      h2 {
        font-size: 1.042vw;
        line-height: 1.25vw;
        font-weight: 400;
        color: rgba(4, 167, 1, 1);
        margin-left: 0.781vw;
      }
      i {
        color: #04a701;
        font-size: 1.771vw;
        font-weight: 900;
        padding-left: 0.781vw;
      }
    }
    .change-password-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1.25rem;
      padding-top: 1.25rem;
      h1 {
        color: #4e6586;
        font-size: 1.458vw;
        line-height: 1.719vw;
        padding-left: 2.083vw;
      }
      .title-column {
        display: flex;
        flex-direction: column;
      }
      .change-border {
        width: 16.563vw;
        height: 2px;
        background-color: #4e6586;
        opacity: 0.2;
        margin-bottom: 2.344vw;
      }
      .back {
        background-color: transparent;
        border: transparent;
        color: rgba(92, 137, 201, 0.7);
        cursor: pointer;
        margin-bottom: 1.042vw;
        padding-top: 4.115vw;
        margin-right: 1.823vw;
        font-size: 0.938vw;
        line-height: 1.146vw;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.104vw;
          background: rgba(92, 137, 201, 0.7);
          opacity: 0;
          transform: scale(0);
        }

        &:hover::before {
          transform: scale(1);
          transition: all 0.4s ease;
          opacity: 1;
        }
      }
    }
    .check {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 1.042vw;
      form {
        .input-fields {
          display: grid;
          grid-template-areas:
            "input icons"
            "label label"
            "small small";
          grid-template-columns: 15.833vw 1.667vw;
          align-items: center;
          width: 17.708vw;
          height: 1.927vw;
          margin-bottom: 3.229vw;
          padding: 0 0.521vw;
          border: 1.5px solid rgba(92, 137, 201, 0.5);
          background-color: #fff;

          input {
            grid-area: input;
            width: 14.167vw;
            height: 100%;
            outline: none;
            font-size: 0.833vw;
            line-height: 1.042vw;
            font-weight: 300;
            background: transparent;
          }

          label {
            grid-area: label;
            color: rgba(211, 77, 77, 1);
            font-size: 0.729vw;
            line-height: 0.885vw;
            font-weight: 400;
            margin-top: 0.417vw;
          }
          small {
            grid-area: small;
            color: rgba(211, 77, 77, 1);
            font-size: 0.729vw;
            line-height: 0.885vw;
            font-weight: 400;
            margin-top: 0.417vw;
          }

          .show-password {
            grid-area: icons;
            display: flex;
            outline: none;
            background-color: transparent;
            border: transparent;
            cursor: pointer;
            i {
              color: rgba(128, 128, 128, 1);
              width: 1.563vw;
              height: 1.563vw;
              font-size: 0.833vw;
              display: flex;
              align-items: center;
              cursor: pointer;
            }
          }
        }
      }

      .to-apply-mb {
        margin-top: 2.083vw;
        margin-bottom: 1.563vw;
        width: 100%;
        display: flex;
        justify-content: center;
        .to-apply {
          background-color: transparent;
          outline: none;
          border: none;
          font-size: 1.458vw;
          line-height: 1.667vw;
          font-weight: 500;
          cursor: pointer;
          color: rgba(92, 137, 201, 0.8);
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .main {
    margin-top: 4vw;
    .profile {
      width: 100%;

      .title {
        justify-content: space-between;
        h1 {
          font-size: 3.385vw;
          line-height: 3.906vw;
          margin-left: 3.906vw;
          margin-bottom: 1.302vw;
        }

        .border {
          width: 37.37vw;
          margin-bottom: 1.953vw;
        }

        .change {
          margin-right: 4.557vw;
          padding-top: 10vw;
          font-size: 2.304vw;
          line-height: 2.825vw;
        }
      }

      .settings-input {
        justify-content: space-between;
        margin-top: 5.208vw;
        .name,
        .login,
        .email,
        .surname,
        .about {
          grid-template-columns: 20.339vw 44.271vw;
          h3 {
            font-size: 2.604vw;
            line-height: 3.125vw;
            margin-right: 4vw;
          }

          .email-column {
            label {
              font-size: 1.823vw;
              line-height: 2.214vw;
              width: 100%;
            }
          }

          .login-message {
            p {
              font-size: 1.823vw;
              line-height: 2.214vw;
            }
          }

          .input {
            width: 44.271vw;
            height: 4.818vw;
            font-size: 1.823vw;
            line-height: 2.214vw;
          }

          .text {
            p {
              font-size: 1.823vw;
              line-height: 2.214vw;
              width: 100%;
            }

            .textarea {
              width: 44.271vw;
              height: 19.531vw;
              font-size: 1.823vw;
              line-height: 2.214vw;
            }
          }
        }
      }

      .apply-mb {
        .apply {
          font-size: 3.385vw;
          line-height: 3.906vw;
        }
      }
    }

    .change-section {
      width: 100%;

      .change-password-title {
        h1 {
          font-size: 3.385vw;
          line-height: 3.906vw;
          margin-left: 3.906vw;

          margin-bottom: 1.302vw;
        }

        .change-border {
          width: 37.37vw;
          margin-bottom: 1.953vw;
        }

        .back {
          margin-right: 4.557vw;
          padding-top: 9vw;
          font-size: 2.304vw;
          line-height: 2.825vw;
        }
      }

      .check {
        width: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-left: auto;
        form {
          .input-fields {
            grid-template-columns: 39vw 6vw;
            width: 44.271vw;
            align-items: center;
            margin-bottom: 8.906vw;
            height: 4.8vw;

            input {
              width: 40vw;
              font-size: 1.823vw;
              line-height: 2.214vw;
              height: 4.318vw;
            }

            label {
              font-size: 1.823vw;
              line-height: 2.214vw;
              width: 100%;
              margin-top: 1vw;
            }

            small {
              font-size: 1.823vw;
              line-height: 2.214vw;
              margin-top: 1vw;
            }

            .show-password {
              i {
                font-size: 1.706vw;
              }
            }
          }
        }

        .to-apply-mb {
          .to-apply {
            font-size: 3.385vw;
            line-height: 3.906vw;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .main {
    margin-top: 10vw;
    .profile {
      width: 100%;

      .title {
        justify-content: space-between;
        h1 {
          font-size: 5.67vw;
          line-height: 7.467vw;
          margin-left: 3.906vw;
          margin-bottom: 1.302vw;
        }

        .border {
          width: 55.133vw;
          margin-bottom: 1.953vw;
        }

        .change {
          margin-right: 4.557vw;
          padding-top: 20vw;
          font-size: 3.967vw;
          line-height: 5.067vw;
        }
      }

      .settings-input {
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 5.208vw;
        .name,
        .login,
        .email,
        .surname,
        .about {
          display: flex;
          flex-direction: column;
          width: 84vw;
          margin-bottom: 8vw;

          h3 {
            font-size: 5.333vw;
            line-height: 6.4vw;
            margin-left: -3vw;
          }

          .email-column {
            label {
              font-size: 3.733vw;
              line-height: 4.533vw;
              width: 100%;
              margin-top: 0;
            }
          }

          .login-message {
            p {
              font-size: 3.733vw;
              line-height: 4.533vw;
            }
          }

          .input {
            width: 78.667vw;
            height: 9.867vw;
            font-size: 4.267vw;
            line-height: 5.067vw;
            padding-left: 2.667vw;
          }

          .text {
            p {
              font-size: 4.267vw;
              line-height: 5.067vw;
              width: 100%;
            }

            .textarea {
              width: 78.667vw;
              height: 40vw;
              font-size: 4.267vw;
              line-height: 5.067vw;
              padding-left: 2.667vw;
            }
          }
        }
      }

      .apply-mb {
        margin-top: 8vw;
        .apply {
          font-size: 7.467vw;
          line-height: 8.8vw;
        }
      }
    }

    .change-section {
      width: 100%;

      .change-password-title {
        h1 {
          font-size: 5.867vw;
          line-height: 7.467vw;
          margin-left: 3.906vw;
          margin-bottom: 1.302vw;

          margin-bottom: 1.302vw;
        }

        .change-border {
          width: 66.133vw;
          margin-bottom: 1.953vw;
        }

        .back {
          margin-right: 4.557vw;
          padding-top: 12vw;
          font-size: 3.967vw;
          line-height: 5.067vw;
        }
      }

      .check {
        width: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-left: auto;
        form {
          .input-fields {
            grid-template-columns: 77vw 5vw;
            width: 85.333vw;
            align-items: center;
            margin-bottom: 9.906vw;
            height: 9.867vw;

            input {
              width: 80vw;
              font-size: 3.733vw;
              line-height: 4.533vw;
              height: 7.867vw;
            }

            label {
              font-size: 3.733vw;
              line-height: 4.533vw;
              width: 100%;
              margin-top: 2vw;
            }

            small {
              font-size: 3.733vw;
              line-height: 4.533vw;
              margin-top: 2vw;
            }

            .show-password {
              i {
                font-size: 3.706vw;
              }
            }
          }
        }

        .to-apply-mb {
          margin-top: 8vw;
          .to-apply {
            font-size: 7.467vw;
            line-height: 8.8vw;
          }
        }
      }
    }
  }
}
</style>
